import Routing from './labs/router/Routing'
// import dotenv from 'dotenv'
// Use the environment variable as needed
function App() {

  return (
    <Routing />
  )
}
export default App
